


















import {Component, Vue, Prop, Watch} from 'vue-property-decorator';
import { AutoCompleteData } from '@/store/models/Letter/AutoCompleteData';
import AutoTextarea from '@/components/UiComponents/AutoTextarea/AutoTextarea.vue'
import * as $ from 'jquery';
import store from '@/store';
import { getNewGuid } from '@/util/utils';
@Component({
    components: {AutoTextarea}
})
export default class CommentEditorMobile extends Vue{
    @Prop() data?: AutoCompleteData[];
    shallShowList = false;
    selectedValue= false;
    comment = '';
    id="";
    inputValue='';
    @Prop() loadedComment?: string;
    get filteredData(){
        if(!this.data) return[];
        return this.data.filter(item=>item.name.includes(this.comment));
    }
   
   created(){
        this.id=getNewGuid();
        if(this.loadedComment!=null){
           this.comment=this.loadedComment;
        }
    }

    mounted(){
        $("#commentDrowpdown1").dropdown({action: 'hide',silent: true});
    }
    showList(e: boolean){
          if(e){
            this.shallShowList=true;
        }else if(e==false && this.selectedValue==false){
            this.shallShowList=false;
        }else if(e==false && this.selectedValue==true){
            this.shallShowList=true;
        }
    }
    selectItem(value: string){
       this.shallShowList = false;
        this.selectedValue=true;
        this.comment = value;
        store.state.eventHub.$emit('setDrowpdownToComment', {value: value, id: this.id})
    }

    @Watch('comment')
    onCommentChanged(n: string, o: string){
        this.$emit('comment-changed',this.comment);
         if(this.filteredData.length<=0){
            this.shallShowList=false;
        }
    }
    onFocusOut(){
        //this.shallShowList = false;
    }
    onTextAreaClick(){
        this.shallShowList = !this.shallShowList;
    }
}
